import React, { useEffect, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import { MODALS } from '@/configs/modals';
import { isEmpty, isFunction } from '@/utils/helpers';
import { useModals } from '@/hooks/useModals';
import 'react-image-lightbox/style.css';

const LightboxModal = () => {
  const modalId = MODALS.lightbox;
  const { params, modalClose } = useModals(modalId);
  const { isOpen, images = [], initIndex, onClose } = params || {};
  const [photoIndex, setPhotoIndex] = useState();

  useEffect(() => {
    isOpen && setPhotoIndex(initIndex);
  }, [isOpen, initIndex])

  const closeModal = () => {
    setPhotoIndex(null);
    modalClose(modalId);
    isFunction(onClose) && onClose();
  };

  if (!isOpen || isEmpty(images) || !images[photoIndex]) return null

  return (
    <Lightbox
      mainSrc={images[photoIndex]}
      prevSrc={images[(photoIndex + images.length - 1) % images.length]}
      nextSrc={images[(photoIndex + 1) % images.length]}
      onCloseRequest={closeModal}
      onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
      onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
      wrapperClassName="lightbox-modal"
    />
  )
};

export default LightboxModal;
